export const SET_FEVICYRL_CONTENT_SUCCESS = 'SET_FEVICYRL_CONTENT_SUCCESS';
export const SET_FEVICYRL_CONTENT_FAIL = 'SET_FEVICYRL_CONTENT_FAIL';

export const SET_WORKSHOP_LIST_SUCCESS = 'SET_WORKSHOP_LIST_SUCCESS';
export const SET_WORKSHOP_LIST_FAIL = 'SET_WORKSHOP_LIST_FAIL';

export const SET_WORKSHOP_CMDI_LIST_SUCCESS = 'SET_WORKSHOP_CMDI_LIST_SUCCESS';
export const SET_WORKSHOP_CMDI_LIST_FAIL = 'SET_WORKSHOP_CMDI_LIST_FAIL';

export const SET_PAYMENT_LIST_SUCCESS = 'SET_PAYMENT_LIST_SUCCESS';
export const SET_PAYMENT_LIST_FAIL = 'SET_PAYMENT_LIST_FAIL';

export const SET_WORKSHOP_AMMD_LIST_SUCCESS = 'SET_WORKSHOP_AMMD_LIST_SUCCESS';
export const SET_WORKSHOP_AMMD_LIST_FAIL = 'SET_WORKSHOP_AMMD_LIST_FAIL';

export const SET_PAYMENT_AMMD_LIST_SUCCESS = 'SET_PAYMENT_AMMD_LIST_SUCCESS';
export const SET_PAYMENT_AMMD_LIST_FAIL = 'SET_PAYMENT_AMMD_LIST_FAIL';

export const SET_MY_DATABASE_SUCCESS = 'SET_MY_DATABASE_SUCCESS';
export const SET_MY_DATABASE_FAIL = 'SET_MY_DATABASE_FAIL';
